<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Emails enviados</h1>

			<!--<div>
				<pdfBtn 
					:filter="string_filter" 
					type="datatable" 
					title="emails"
					datatable="Email"
					:data_head="data_head" 
					:data_body="data_body" 
				/>
			</div>-->
	    </div>

	    <filtros :filter_data="filter_data" @filtrar="filtrar" />

	    <table class="table table-striped table-sm">
    		<thead align="center">
    			<th @click="orderBy('id')"      >ID 	<font-awesome-icon v-if="direction.by == 'id'"      :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('origem')"  >ORIGEM	<font-awesome-icon v-if="direction.by == 'origem'"	:icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('destino')" >DESTINO<font-awesome-icon v-if="direction.by == 'destino'"	:icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('assunto')" >ASSUNTO<font-awesome-icon v-if="direction.by == 'assunto'"	:icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('data')"    >DATA	<font-awesome-icon v-if="direction.by == 'data'"	:icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('hora')"    >HORA	<font-awesome-icon v-if="direction.by == 'hora'"	:icon="order_icon" size="xs" /></th>
    			<th></th>
    		</thead>
			
			<transition mode="out-in" name="leftIn">
				<tbody v-if="emails" align="center">
	    			<tr v-for="(e, index) in emails.result.data" :key="index">
						<td>{{ e.id }}</td>
						<td>{{ Phone(e.origem) }}</td>
						<td>{{ e.destino }}</td>
						<td>{{ e.assunto }}</td>
						<td>{{ e.created_at | moment("DD/MM/YYYY") }}</td>
						<td>{{ convert_hor(e.created_at) | moment("HH:mm:ss") }}</td>
						<td><font-awesome-icon icon="eye" class="info pointer" @click="view(e)" /></td>
					</tr>

	    		</tbody>
	    		<div v-else><Loading/></div>
			</transition>
	    </table>

    	<controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />

    	<modal :email="modal_data" />
	</section>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import pdfBtn   from "@/components/Tools/Pdf.vue"
	import filtros  from "@/components/Tools/Filtro.vue"
	import modal    from "@/components/Modal/Views/Email.vue"
	import controls from "@/components/Tools/Table_Control.vue"

	export default {
		name: "Emails",
		props: ["table", "method"],
		mixins: [api, replace],
		components: { controls, filtros, modal, pdfBtn },

		data() { return {
			emails: null,
			constrol_data: {},
			modal_data: {},

			alert: { type: "", msg: "" },
			direction: { order: "desc", by: "id" },

			pagination: "10?",
			string_filter: "",

			filter_data: [
				{ name: "id",      label: "id",      type: "text", data_get: ""},
				{ name: "date",    label: "data",    type: "date", data_get: ""},
				{ name: "origem" , label: "origem",  type: "text", data_get: ""},
				{ name: "destino", label: "destino", type: "text", data_get: ""},
				{ name: "assunto", label: "assunto", type: "text", data_get: ""}
			],
			data_head: ["ID", "ORIGEM", "DATA", "HORA", "DESTINO", "ASSUNTO"],
			data_body: ["id", "origem", "data", "hora", "destino", "assunto"]
		}},

		created() {
			this.get_data()
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down"
			}
		},

		methods: {
			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc'
				}

				else this.direction.by = payload

				this.get_data()
			},

			filtrar(payload) {
				this.string_filter = payload
				this.get_data()
			},

			async get_data() {
				this.emails = null
				this.emails = await this.GET("Email", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}`)

				this.constrol_data = {
					current_page: this.emails.result.current_page,
					last_page:    this.emails.result.last_page,
					per_page:     this.emails.result.per_page,
					total:        this.emails.result.total,
				}
			},

			navigate(payload) {
				this.pagination = payload
				this.get_data()
			},

			view(payload) { 
				this.modal_data = payload
				$("#modal-email").modal()
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger"
				this.alert.msg  = payload.result

				$("#modal-cadastro-unidade").modal('hide')
				this.get_data()
				$("#app-alert").show()
				setTimeout(() => $("#app-alert").hide(), 3000 )
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			emit_pdf() {
				const header = ["ID", "ORIGEM", "DATA", "HORA", "DESTINO", "ASSUNTO"]
				const body   = []
				const data   = this.emails.result.data

				data.forEach( index => {
					const row = [
						index.id,
						this.Phone(index.origem),
						this.$moment(index.data).format("DD/MM/Y"),
						index.hora,
						index.destino,
						index.assunto,
					]

					body.push(row)
				})
				
				this.pdf_post_datatable( {type: "denúncias", user: this.$store.state.user.name, header, body} )
			},
		},
	};
</script>

<style>
	
</style>